import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { CheckBox, TextBox, IntBox } from 'fw/forms';
import { ActionButton, Label } from 'fw/components';
import { SetupTab } from 'areas/shared/pages/setup';
import PrivilegeMultiselect from './PrivilegeMultiselect';
import LoadFromTemplateModal from './LoadFromTemplateModal';
import * as App from 'modules/app/App';
import * as API from 'modules/app/API';
import * as Modals from 'fw/globals/Modals';
import { UserTypeCombo } from 'areas/shared/controls'
import * as Notifications from 'fw/globals/Notifications';

class RoleInfoTab extends SetupTab {
	initialForm() {
		return {
			roleName: "",
			active: true,
			description: "",
			sessionTimeout: "",
			privileges: [],
			rowVersion: null,
			userTypeCode: ""
		}
	}

	privileges() {
		return {
			add: App.hasPrivilege("AdminRoleSetupAdd"),
			edit: App.hasPrivilege("AdminRoleSetupEdit"),
			delete: App.hasPrivilege("AdminRoleSetupDelete")
		}
	}

	urls() {
		return {
			get: API.Security.url('/roleSetup/getRoleInfo'),
			save: API.Security.url('/roleSetup/saveRoleInfo'),
			create: API.Security.url('/roleSetup/createRole')
		}
	}

	getRequest(selectedId) {
		return {
			roleId: selectedId
		}
	}

	saveRequest() {
		let privileges = [];

		this.state.data.resourceTree.forEach((r) => {
			this.filterPrivileges(r).forEach((p) => {
				privileges.push(p);
			});
		});

		return {
			roleId: this.props.selectedId,
			roleName: this.state.form.roleName,
			description: this.state.form.description,
			sessionTimeout: this.state.form.sessionTimeout,
			active: this.state.form.active,
			userTypeCode: this.state.form.userTypeCode,
			rowVersion: this.state.form.rowVersion,
			privileges: privileges
		}
	}

	deleteRequest() {
		return {
			roleId: this.props.selectedId
		}
	}

	ready = () => {
		this.handleUserType(this.state.form.userTypeCode)
		this.focusControl && this.focusControl.focus();
	}

	// Since form.privileges may have resources as selected, we need to filter privileges only
	filterPrivileges(resource) {
		let items = [];

		resource.childs.forEach((rc) => {
			this.filterPrivileges(rc).forEach((i) => {
				items.push(i);
			});
		})

		if (resource.privileges && resource.privileges.length > 0)
			resource.privileges.forEach((p, pi) => {
				if (this.state.form.privileges.includes(p.privilegeCode))
					items.push(p.privilegeCode);
			});

		return items;
	}

	handleLoadFromTemplateConfirm = (roleId) => {
		const me = this;
		const rq = this.getRequest(roleId);

		API.Security.get('/roleSetup/getRoleInfo', rq,
			{
				success: (r) => {
					this.setState({
						form: {
							sessionTimeout: r.data.sessionTimeout,
							privileges: r.data.privileges,
							roleName: me.state.form.roleName,
							description: me.state.form.description,
							active: me.state.form.active,
							rowVersion: me.state.form.rowVersion
						}
					});

					this.dirt();
				},
				error: (r) => {
					this.props.onError(r.error);
				}
			});
	}

	handleLoadFromTemplateClick = () => {
		this._loadFromTemplateModal.open();
    }
    
    handleDeleteRole = () => {
		const me = this;

		Modals.remove({
            title: "Deleting role",
            elementType: "role",
            name: this.state.form.roleName,
            onYes: () => {
                API.Security.post('/roleSetup/deleteRole', { roleId: me.props.selectedId },
				{
					success: (r) => {
						me.props.onSuccess(r.message);
						me.props.onDelete();
					},
					error: (r) => {
						me.props.onError(r.error);
					}
				});
            }
        });
	}

	onUserTypeChange = (value) => {
		this.handleUserType(value.value);
	}

	handleUserType = (value) => {
		const me = this;

		API.Security.post('/roleSetup/loadRoleInfo', { 
			roleId: me.props.selectedId, 
			userTypeCode: value },
		{
			success: (r) => {
				this.setState({ data: r.data });
			},
			error: (r) => {
				Notifications.error(r.error.errorMessage);
			}
		});
	}

	renderActions() {
		return (
			<div className="pull-right">
				<ActionButton id="btnLoadFromTemplate" onClick={() => this.handleLoadFromTemplateClick()} icon="download">Load From Template</ActionButton>

				{App.hasPrivilege("AdminRoleSetupDelete") &&
					(!this.state.adding) &&
					<ActionButton id="btnDeleteRole" onClick={this.handleDeleteRole} icon="trash">Delete Role</ActionButton>
				}
			</div>)
	}

	renderContent() {
		return (
			<LoadFromTemplateModal
				onConfirm={this.handleLoadFromTemplateConfirm}
				ref={(c) => { this._loadFromTemplateModal = c }} />)
	}

	renderForm() {
		return (
			<React.Fragment>
				<Row>
					<Col md={4}>
						<FormGroup>
							<Label htmlFor="roleName" required>Role Name</Label>
							<TextBox 
								name="roleName" 
								placeholder="Role Name"
								maxLength={30} 
								required 
								ref={(c) => { this.focusControl = c; }} />
						</FormGroup>
						<FormGroup>
							<Label htmlFor="description" required>Role Description</Label>
							<TextBox 
								name="description" 
								placeholder="Role Description"
								maxLength={128} 
								required />
						</FormGroup>
					</Col>
					<Col md={4}>
						<FormGroup>
							<Label htmlFor="sessionTimeout" required>User Type</Label>
							<UserTypeCombo name="userTypeCode" onChange={this.onUserTypeChange} clearable />
						</FormGroup>
						<FormGroup>
							<Label>&nbsp;</Label>
							<CheckBox name="active" label="Active" />
						</FormGroup>
					</Col>
					<Col md={4}>
						<FormGroup>
							<Label htmlFor="sessionTimeout" required>Session timeout (mins)</Label>
							<IntBox 
								name="sessionTimeout" 
								placeholder="Timeout"
								maxLength="2" 
								style={{ width: "80px" }} 
								required 
								positiveOnly />
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<Label htmlFor="privileges">Privileges</Label>
						<PrivilegeMultiselect name="privileges" items={this.state.data.resourceTree} />
					</Col>
				</Row>
			</React.Fragment>
		)
	}
}

export default RoleInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/roleSetup/roleInfo/RoleInfoTab.js